module.exports = __webpack_public_path__ + "static/media/elegant.cdc11263.png";